module.exports = __webpack_public_path__ + "ec2c4786f3dba9acf07ceba3c1081a49.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/raw-ingredient-icon.png
// module id = 3166
// module chunks = 0